import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ImageUrlComponent from '../../components/ImageUrlComponent';
import { MaterialStep } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Training/Courses/Lessons/PathItems';

interface StepViewProps {
  open: boolean;
  onClose: () => void;
  onSave: (step: MaterialStep) => void;
  initial?: MaterialStep;
}

const StepView: React.FC<StepViewProps> = ({ open, onClose, onSave, initial }) => {
  const [name, setName] = useState(initial?.name || '');
  const [description, setDescription] = useState(initial?.description || '');
  const [thumbnail, setThumbnail] = useState(initial?.thumbnail.url || '');
  // Removed duration state

  useEffect(() => {
    setName(initial?.name || '');
    setDescription(initial?.description || '');
    setThumbnail(initial?.thumbnail.url || '');
  // Removed duration reset
  }, [open, initial]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Step
        <IconButton onClick={onClose} size="small" sx={{ ml: 2 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', gap: 3, mt: 1 }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField label="Name" value={name} onChange={e => setName(e.target.value)} fullWidth autoFocus />
            <TextField label="Description" value={description} onChange={e => setDescription(e.target.value)} fullWidth multiline minRows={6} />
          </Box>
          <Box sx={{ minWidth: 780, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <ImageUrlComponent value={thumbnail} onChange={(img) => setThumbnail(img ?? '')} />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end', pr: 3, pb: 2 }}>
        <Button
          variant="contained"
          onClick={() => onSave({ id: initial?.id ?? '', name, description, thumbnail: { url: thumbnail } })}
          disabled={!name.trim()}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StepView;
